import { render, staticRenderFns } from "./PhotoLibraryConfig.vue?vue&type=template&id=0046c5d8&"
import script from "./PhotoLibraryConfig.vue?vue&type=script&lang=js&"
export * from "./PhotoLibraryConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports